// extracted by mini-css-extract-plugin
export default {"footer":"SystemFooter_footer__bGXWP"};